import type { SettingView } from "@elektr/shared";

// Kalitlar literal: i18n qamrov testi dinamik kalitlarni ko'rmaydi
export const FIELD_LABEL = {
  "general.public_base_url": "settings.f_public_base_url",
  "general.default_language": "settings.f_default_language",
  "telegram.bot_token": "settings.f_bot_token",
  "telegram.bot_username": "settings.f_bot_username",
  "sms.enabled": "settings.f_sms_enabled",
  "sms.provider": "settings.f_sms_provider",
  "sms.eskiz_email": "settings.f_eskiz_email",
  "sms.eskiz_password": "settings.f_eskiz_password",
  "sms.eskiz_from": "settings.f_eskiz_from",
  "sms.playmobile_login": "settings.f_playmobile_login",
  "sms.playmobile_password": "settings.f_playmobile_password",
  "sms.playmobile_originator": "settings.f_playmobile_originator",
  "email.alert_emails": "settings.f_alert_emails",
  "email.host": "settings.f_email_host",
  "email.port": "settings.f_email_port",
  "email.user": "settings.f_email_user",
  "email.password": "settings.f_email_password",
  "email.use_tls": "settings.f_email_use_tls",
  "email.from_address": "settings.f_email_from",
  "hosting.hetzner_token": "settings.f_hetzner_token",
  "storage.endpoint_url": "settings.f_storage_endpoint",
  "storage.public_endpoint_url": "settings.f_storage_public_endpoint",
  "storage.region": "settings.f_storage_region",
  "storage.bucket": "settings.f_storage_bucket",
  "storage.access_key": "settings.f_storage_access_key",
  "storage.secret_key": "settings.f_storage_secret_key",
  "storage.free_gb": "settings.f_storage_free_gb",
  "storage.price_per_tb_usd": "settings.f_storage_price",
  "backup.repository": "settings.f_backup_repository",
  "backup.password": "settings.f_backup_password",
  "backup.aws_access_key_id": "settings.f_backup_key_id",
  "backup.aws_secret_access_key": "settings.f_backup_secret",
} as const;

export const GROUP_TITLE = {
  general: "settings.g_general",
  telegram: "settings.g_telegram",
  sms: "settings.g_sms",
  email: "settings.g_email",
  hosting: "settings.g_hosting",
  storage: "settings.g_storage",
  backup: "settings.g_backup",
} as const;

export const GROUP_HINT = {
  general: "settings.h_general",
  telegram: "settings.h_telegram",
  sms: "settings.h_sms",
  email: "settings.h_email",
  hosting: "settings.h_hosting",
  storage: "settings.h_storage",
  backup: "settings.h_backup",
} as const;

export const CHOICE_LABEL = {
  eskiz: "settings.provider_eskiz",
  playmobile: "settings.provider_playmobile",
  uz: "settings.lang_uz",
  ru: "settings.lang_ru",
} as const;

export type GroupName = keyof typeof GROUP_TITLE;
export type FieldKey = keyof typeof FIELD_LABEL;

/** Provayderga xos maydonlar faqat tanlangan provayder uchun ko'rinadi. */
export function isVisible(key: string, current: (k: string) => string): boolean {
  if (key.startsWith("sms.eskiz_")) return current("sms.provider") === "eskiz";
  if (key.startsWith("sms.playmobile_")) return current("sms.provider") === "playmobile";
  return true;
}

export const labelOf = (s: SettingView): string => FIELD_LABEL[s.key as FieldKey] ?? s.key;
